export const getBasePath = (resourceType: string): string => {
  const pathes: { [k: string]: string } = {
    clients: '/clients/individuals',
    clientGroups: '/clients/client_groups',
    exercises: '/exercises',
    workoutExercises: '/workout_exercises',
    workoutTemplates: '/workout_templates',
    warmups: '/warmups',
    cooldowns: '/cooldowns',
    programTemplates: '/program_templates',
    exerciseProperties: '/exercise_properties',
    personalWarmups: '/personal_warmups',
    personalCooldowns: '/personal_cooldowns',
    personalWorkouts: '/personal_workouts',
    personalPrograms: '/personal_programs',
    personalExercises: '/personal_exercises',
  };

  return pathes[resourceType] || resourceType;
};

export const getEntityType = (resourceType: string): string => {
  const types: { [k: string]: string } = {
    warmups: 'warmup',
    cooldowns: 'cooldown',
    exercises: 'exercise',
    workoutTemplates: 'workout',
  };
  return types[resourceType] || resourceType;
};

export const getEntityPath = (entity: any, basePath?: string) => {
  let root = basePath;
  const isFolder = entity.parent_id;

  if (entity.is_warmap) {
    root = '/warmups';
  }

  if (entity.is_cooldown) {
    root = '/cooldowns';
  }

  return `${root}${isFolder ? '_folder' : ''}/${entity.id}`;
};

// Generate unique IDs
export const ID = () => (
  `_${Math.random()
    .toString(36)
    .substr(2, 9)}`
);

export const updateItemPositonOnList = (list: any[]): any[] => list.reduce(
  (accumulator, item, index) => {
    const position = index + 1;
    if (item.position === position) return accumulator;

    return [
      ...accumulator,
      {
        ...item,
        position,
      },
    ];
  },
  [],
);
